module.exports = __webpack_public_path__ + "media/images/big/img7-ad900b69bab36cb7d67a0cb27d6ef67c.jpg";